import React from "react";
import { Route, Switch } from "react-router-dom";
import PageWrapper from "../common/PageWrapper";
import HomePage from "../page/Home";
import StarGame from "../page/ProjectWork/StarGame";
import GitHub from "../page/ProjectWork/GitHub";
import WhatsApp from "../page/ProjectWork/WhatsApp";
import URLShare from "../page/ProjectWork/URLShare";
import AnalogClock from "../page/ProjectWork/Neumorphism/AnalogClock";
import AboutPage from "../page/About";
// import TicTacTao from "Tic-Tac-Toe/TicTacTao";
import CoursesPage from "../page/ProjectWork/Courses/CoursesPage";
import ManageCoursePage from "../page/ProjectWork/Courses/ManageCoursePage"; // eslint-disable-line import/no-named-as-default
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as ROUTES from "../constants/routes";
import "./index.scss";

const App = () => {
  return (
    <PageWrapper>
      <Switch>
        <Route exact path={ROUTES.LANDING} component={HomePage} />
        <Route path={ROUTES.ABOUT} component={AboutPage} />

        {/* <Route path="tic" component={TicTacTao} /> */}

        <Route path="/courses" component={CoursesPage} />
        <Route path="/course/:slug" component={ManageCoursePage} />
        <Route path="/course" component={ManageCoursePage} />

        <Route path={ROUTES.GITHUB} component={GitHub} />
        <Route path={ROUTES.URL_SHARE} component={URLShare} />

        <Route path={ROUTES.WHATS_APP} component={WhatsApp} />
        <Route path={ROUTES.STAR_GAME} component={StarGame} />
        <Route path={ROUTES.ANALOG_CLOCK} component={AnalogClock} />

        <Route component={HomePage} />
      </Switch>
      <ToastContainer autoClose={3000} hideProgressBar />
    </PageWrapper>
  );
};

export default App;
